function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

function debounce(callback, wait) {
    let timerId;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            callback(...args);
        }, wait);
    };
}

async function updateQuantity(id, quantity) {
    console.log('updateQuantity()');
    
    const body = JSON.stringify({
        'id': id,
        'quantity': quantity
    });

    window.GTM.changeQuantity(id, quantity);

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        }).then((response) => {
        
        Cart.updateContent();
        
        updateTestDriveForm();
        
        VeloOffer.UpdatePDP();

        if (typeof EsTracking !== 'undefined') {
            EsTracking.onCartChange();
        }
        if (response.status) {
            // Error function
            this.errorMessage(response)
            return;
        }

        // Emit event if quantity is zero
        if (quantity === 0) {
            const event = new CustomEvent('product:removed', {
                detail: {
                    variantId: id
                }
            });
            document.dispatchEvent(event);
        }
    }).catch(function (err) {
        console.error('Something went wrong.', err);
    });
}

async function removeAllTestDrive(updatesItems) {

    let updates = updatesItems.reduce((acc,curr)=> (acc[curr]=0, acc),{});

    updates = {updates}

    const body = JSON.stringify(updates);

    window.GTM.changeQuantity(updatesItems[0], 0);

    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        }).then((response) => {

        Cart.updateContent();

        updateTestDriveForm();

        if (typeof EsTracking !== 'undefined') {
            EsTracking.onCartChange();
        }
        if (response.status) {
            // Error function
            this.errorMessage(response)
            return false;
        }
    }).catch(function (err) {
        console.error('Something went wrong.', err);
    });

    return false;
}

// check cart bonuses
function checkBonusesInCart() {
    const headTotalXp = $('.js-cart-aside-head-total-xp');
    const cartItemsXpProducts = $('.cart__wrapper [data-price-xp]');
    let totalXp = 0;

    if (cartItemsXpProducts.length) {
        $.each(cartItemsXpProducts, function( index, product ) {
            totalXp = totalXp + +$(product).data('price-xp');
        });
    } else if (headTotalXp.length) {
        const headTotalXpSplited = headTotalXp[0].innerHTML.split('&');
        totalXp = headTotalXpSplited[0];
    }

    console.log(totalXp + ' XP are in the cart');
    return totalXp;
}

// limit bonus products
function limitBonusProducts(bonusPrice, productQuantity, inputQuantity, previousValue = false) {

    const balance = window.forTreeJSConf.customer.bonusBalance,
        totalBonusPrice = productQuantity * bonusPrice;

    if ( (totalBonusPrice > (balance - checkBonusesInCart()) / bonusPrice) && (totalBonusPrice > balance - bonusPrice) ) {
        let maxAvailableQuantity = Math.trunc((balance - checkBonusesInCart()) / bonusPrice);
        
        if (previousValue) {
            maxAvailableQuantity = maxAvailableQuantity + previousValue;
        }
        console.log(maxAvailableQuantity, 'maxAvailableQuantity');

        inputQuantity.val(maxAvailableQuantity);
    }
}

if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
        }

        formSubmit(evt) {
            evt.preventDefault();
            this.querySelector('button[name="add"]').classList.add('loading');
            this.querySelector('button[name="add"] .loading-overlay__spinner').classList.remove('hidden');
            this.querySelector('button[name="add"] .btn__text:not(.cart-btn-hidden)').style.opacity = "0";


            let productId = $(this.form).find('input[name="id"]').val(),
                productInCart = $('cart-item[data-item-id="'+productId+'"]'),
                inputQuantity = $(this.form).find('input[name="quantity"]'),
                productQuantity = parseInt($(this.form).find('input[name="quantity"]').val()),
                Config = globalConf(globalConfig),
                maxVal = Config.productLimit;

            if(productInCart.data('vendor') === 'cigarettes'){
                maxVal = Config.productLimitCigarette;
            } else {
                maxVal = Config.productLimit;
            }

            if ($(this.form).closest('.product-card--bonus').length) {
                const bonusPrice = $(this.form).closest('.product-card--bonus').find('[data-bonus-price]').data('bonus-price');
                limitBonusProducts(+bonusPrice, productQuantity, inputQuantity);
            }

            if (productInCart.length){
                let productInCartQuantity = parseInt(productInCart.find('.quan-input').val());

                if(maxVal === productInCartQuantity){
                    this.setImageToAnimate();
                    this.success(true);
                    return false;
                } else if(maxVal > productInCartQuantity && ((productQuantity + productInCartQuantity) > maxVal)) {
                    $(this.form).find('input[name="quantity"]').val(maxVal - productInCartQuantity);
                }
            }

            window.GTM.addToCart($(this.form).find('[name="id"]').val(), $(this.form).find('input[name="quantity"]').val());

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);

            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
                        return;
                    }
                    // Succses function
                    this.setImageToAnimate();
                    this.success(false, response); // Pass response to success method
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        errorMessage(resp) {
            // alert(resp.description)
            const _this = this;
            console.log(resp.description);
            this.querySelector('button[name="add"]').classList.remove('loading');
            this.querySelector('button[name="add"] .loading-overlay__spinner').classList.add('hidden');
            this.querySelector('button[name="add"] .btn__text:not(.cart-btn-hidden)').style.opacity = "1";
            if (resp.status === 422) {
                this.querySelector('button[name="add"]').classList.add('disabled');
                this.querySelector('.quantity-input-minus').classList.add('disabled');
                this.querySelector('.quantity-input-plus').classList.add('disabled');
                $(this.form).find('input[name="quantity"]').val(1);
                $(this.form).find('input[type="number"]').val(1);
                this.querySelector('button[name="add"] .btn__text:not(.cart-btn-hidden)').textContent = 'Очікується';
            } else {
                
            }
        }

        success(added = false, response = null) {
            console.log('product form success');
            
            const _this = this;

            if($(this.form).data('test-drive')){
                this.updateTestDriveForm();
            }

            this.querySelector('button[name="add"]').classList.remove('loading');
            this.querySelector('button[name="add"] .btn__text:not(.cart-btn-hidden)').style.opacity = "1";

            this.querySelector('button[name="add"]').classList.add('cart-added')
            this.querySelector('button[name="add"] .loading-overlay__spinner').classList.add('hidden');

            if ( $('.template-suffix-test-drive').length === 0 ) {
                setTimeout(() => {
                    this.querySelector('button[name="add"]').classList.remove('cart-added');
                    this.querySelector('button[name="add"] .loading-overlay__spinner').classList.add('hidden');
                }, 3000)
            }

            $(this.form).find('input[name="quantity"]').val(1);
            $(this.form).find('input[type="number"]').val(1);

            const productFixedForm = _this.closest('.fixed-form');
            if ( productFixedForm ) {
                productFixedForm.classList.remove('added')
            }

            //esputnik

            if (typeof EsTracking !== 'undefined') {
                EsTracking.onCartChange();
            }

            // not add to cart when limits
            if ((response.quantity >= 3 && response.vendor === 'Cigarettes') || (response.quantity >= 20)) {
                const productForm = _this.closest('product-form');
                $(productForm).find('button[name="add"]').addClass('disabled');
                $(productForm).find('.quantity-input-btn').addClass('disabled');
                $(productForm).find('.has-tt').removeClass('disactive');
            }

            if(!added){
                //upd popup content
                Cart.updateContent();
                // Emit event after cart is updated
                if (response) {
                    this.emitAddToCartEvent(response);
                }
            }
        }

        updateTestDriveForm(){
            const _this = this;
            fetch(`${_this.form.dataset.url}`)
            .then((response) => {
                return response.text();
            })
            .then((response_html) => {
                const html = new DOMParser().parseFromString(response_html, 'text/html')

                document.querySelector('product-form .product-form-inner').innerHTML = html.querySelector('product-form .product-form-inner').innerHTML;
                document.querySelector('.product-fixed-form').innerHTML = html.querySelector('.product-fixed-form').innerHTML;
                document.querySelector('.fixed-form--mobile').innerHTML = html.querySelector('.fixed-form--mobile').innerHTML;

                DefaultFunctions.buttons();

            })
            .catch((e) => {
                console.log(e);
            });

        }

        setImageToAnimate() {
            const _this = this;
            let image;
            const productCard = _this.closest('.product-card');
            const newVeloProductCard = _this.closest('.new-product-card');
            const productMainForm = _this.closest('.product-form');
            const productFixedForm = _this.closest('.fixed-form');
            const about_glo_form = _this.closest('.ab-glo-devices-item');
            const bannerBUY = _this.closest('.main-slider-item');
            const flavorMap = _this.closest('.flavour-map-slider-item');

            if ( flavorMap ) {
                image = flavorMap.querySelector('.slider-item-images-stick img');
            }

            if ( productFixedForm ) {
                image = productFixedForm.querySelector('.fixed-form-added-img img');
            }
            //product card
            if (productCard) {
                image = productCard.querySelector('.product-card-img-media img:not(.hidden)');
            }
            //new velo product card
            if (newVeloProductCard) {
                image = newVeloProductCard.querySelector('.new-product-card__image img:not(.hidden)');
            }
            //product page
            if (productMainForm) {
                // if product media has slider images
                document.querySelector('.product-gallery-images').classList.contains('slick-slider') ?
                    image = document.querySelector('.slick-current .product-featured-image img:not(.hidden)') :
                    image = document.querySelector('.product-featured-image img:not(.hidden)');
            }
            //about glo page
            if ( about_glo_form ) {
                image = about_glo_form.querySelector('.ab-glo-devices-item-img img:not(.hidden)');
            }

            //buy from banner
            if ( bannerBUY ) {
                image = bannerBUY.querySelector('.main-banner-variant-image:not(.hidden)');
            }

            if (image) {
                ShopifyFunctions.animImageToCart($(image));
            }
        }

        emitAddToCartEvent(response) {
            console.log('emitAddToCartEvent()', response);
            if (response && response.variant_id) {
                const event = new CustomEvent('product:added', {
                    detail: {
                        product: response.variant_id
                    }
                });
                console.log('Product added evt dispatch:', response.variant_id);
                document.dispatchEvent(event);
            }
        }
    });
}

async function updateCart(formData) {
    fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        body: formData
    }) .then((response) => {
        return response.text();
    }).then((data ) => {
        Cart.updateContent();
    })
}

$(document).ready(function () {
   if ( $('.fixed-form').length ) {
       let formToCopy = $('.fixed-form');

       const firstSection = $('#MainContent').find('.shopify-section:first-child');
       const secondSection = $('#MainContent').find('.shopify-section:first-child + .shopify-section > section');
       formToCopy.insertAfter(firstSection).removeClass('hidden');

       secondSection.css('margin-top', '0');

   }

   // $(document).on('change keyup', '.cart-item-quan input', function (evt) {
   //     const line = $(this).closest('.cart-item-quan').attr('data-line');
   //     var quantity = parseInt($(this).closest('.cart-item-quan').find('input').val());
   //
   //     if($(this).closest('cart-item').find('[data-price-xp]').length){
   //         var bonuce = $(this).closest('cart-item').find('[data-price-xp]').data('price-xp');
   //     } else {
   //         var bonuce = false;
   //     }
   //
   //     if(quantity >= 5){
   //         quantity = 5;
   //     }
   //
   //     updateQuantity(line, quantity, bonuce)
   //
   // });
    
    var quanInput = $('.quan-input');
    
    quanInput.each(function() {
        $(this).attr('previous', $(this).val());
    });
    
    let debounceTimer;
    
    $(document).on('input', '.quan-input', function() {
        
        var previousValue = $(this).attr('previous');
        var currentValue = $(this).val();
        
        clearTimeout(debounceTimer);
        
        const line = $(this).closest('.cart-item-quan').attr('data-line'),
            input = $(this).closest('.cart-item-quan').find('input'),
            vendor = $(this).closest('cart-item').data('vendor'),
            Config = globalConf(globalConfig),
            minValue = +input.attr('min');
            
        
        // var maxValue = Config.productLimit;
        var maxValue = +input.attr('max');
        var tmpVal,
            quantity;
        
        if (vendor === 'cigarettes') {
            maxValue = Config.productLimitCigarette;
        }
        
        if (parseInt(input.val()) === maxValue) {
            return;
        }

        if ($(this).closest('[data-bonus-product-price]').length) {
            const bonusPrice = $(this).closest('[data-bonus-product-price]').data('bonus-product-price');
            limitBonusProducts(+bonusPrice, +input.val(), input, +previousValue);
        }
        
        if (input.val() > maxValue) {
            $(this).siblings('.quan-btn-plus').addClass('disabled has-tt').append('<span class="tt">Щоб купити більше '+maxValue+' одиниць товару звернись будь-ласка в службу підтримки</span>');
            $(this).siblings('.quan-btn-plus').find('.tt').css({
                "opacity": "1",
                "z-index": "1",
                "visibility": "visible"
            });
        } else {
            $(this).siblings('.quan-btn-plus').removeClass('disabled has-tt').find('span.tt').remove();
            $(this).siblings('.quan-btn-plus').find('.tt').removeAttr('style');
        }
        
        input.val(function (i, val) {
            if((+val + 1 === maxValue) || +val >= maxValue){
                return maxValue;
            } else {
                tmpVal = +val;
                return tmpVal;
            }
        });
        
        quantity = parseInt(input.val()) || 1;
        
        const lineItem = $(this).closest('[data-item-id]');
        let offerItem,
            offerQuantity,
            offerQuantityMax,
            offerVariantId,
            isCitrus = false;
        
        if (lineItem.hasClass('velo_specific_offer_main_variant')) {
            isCitrus = true;
        }
        
        if (isCitrus) {
            offerItem = $(document).find(".velo_specific_offer[data-item-id]");
            offerQuantity = parseInt(offerItem.find(".quan-input").val());
            offerQuantityMax = parseInt(offerItem.find(".quan-input").attr("max"));
            offerVariantId = offerItem.attr("data-item-id");
        }
        
        debounceTimer = setTimeout(function () {
            if (isCitrus) {
                if (quantity >= offerQuantityMax) {
                    offerQuantity = offerQuantityMax;
                    
                    const formData = new FormData();
                    formData.append(`updates[${line}]`, quantity);
                    formData.append(`updates[${offerVariantId}]`, offerQuantity);
                    
                    updateCart(formData);
                    
                    return;
                }
                
                const formData = new FormData();
                formData.append(`updates[${line}]`, quantity);
                formData.append(`updates[${offerVariantId}]`, quantity);
                
                updateCart(formData);
                
                return;
            }
            
            updateQuantity(line, quantity)
            $(this).attr('previous', currentValue);
        }.bind(this), 1000);
    });
   
   $(document).on('click', '.cart-item-quan .quan-btn', function (evt) {
        console.log('qty button click');
        console.log('qty button evt:', evt);
        console.log('qty button evt.target:', evt.target);

        if (evt.target.classList.contains('disabled')) {
            console.log('buttons has disabled class, return');
            return;
        }

       let line = $(this).closest('.cart-item-quan').attr('data-line'),
             input = $(this).closest('.cart-item-quan').find('input'),
             variantId = $(this).closest(".cart-item").attr('data-item-id'),
             vendor = $(this).closest('cart-item').data('vendor'),
             minValue = +input.attr('min'),
             Config = globalConf(globalConfig),
             maxValue = parseInt($(this).closest('.cart-item-quan').find('input').attr("max"));
       var tmpVal,
           quantity;

       if(vendor === 'cigarettes'){
           maxValue = Config.productLimitCigarette;
       }

       if($(this).hasClass('quan-btn-plus')){
           if (parseInt(input.val()) === maxValue){
               return;
           }
           input.val(function (i, val) {
               if((+val + 1 === maxValue) || +val >= maxValue){
                   return maxValue;
               } else {
                   tmpVal = +val + 1;
                   return tmpVal;
               }
           });
       }

       if($(this).hasClass('quan-btn-minus')){
           if (parseInt(input.val()) === minValue){
               return;
           }
            input.val(function (i, val) {
                   if (+val === minValue + 1 || +val === minValue) {
                       tmpVal = minValue;
                   } else {
                       tmpVal = +val - 1;
                   }

                   return tmpVal
               });
       }

       quantity = parseInt(input.val());
       
       // velo offer
       
       const cartLine = $(this).closest('.cart-item');
       
       if ( cartLine.hasClass("velo_specific_offer_main_variant") ) {
           const offerVariant = $(document).find(".cart-item.velo_specific_offer");
           const offerLine = offerVariant.attr('data-line');
           const offerVariantId = offerVariant.attr("data-item-id");
           let offerQuantity = quantity;
           const offerQuantityMax = parseInt(offerVariant.find(".quan-input").attr("max"));
           
           if ( quantity >= offerQuantityMax ) {
               offerQuantity = offerQuantityMax;
           }
       
           const formData = new FormData();
           formData.append(`updates[${variantId}]`, quantity);
           if (offerVariantId) {
            formData.append(`updates[${offerVariantId}]`, offerQuantity);
           }
           
           
           fetch(`${routes.cart_update_url}`, {
               method: 'POST',
               body: formData
           }) .then((response) => {
               return response.text();
           }).then((data ) => {
               Cart.updateContent();
           })
           
           return;
       }
       
       updateQuantity(line, quantity)

   });

});

